var app = angular.module('directives.booking');

app.directive('booking', [
    'configs',
    '$state',
    function (configs, $state) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.', '') + '.html');//looking for template with moduleName
        } catch (e) {
            tmplUrl = require('../templates/index.html')//if error(no such file), use default template
        }

        return {
            template: tmplUrl,
            controller: 'bookingCtrl',
            link: function (scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('bookingCtrl', function ($scope, $rootScope, PortalApi, $stateParams, $compile, Notification, $translate, Localization, configs, $state, Pay, AmountCommission, $timeout, ClientCards) {

    $scope.reservePlace = function(data) {
        Pay.data.booking.reqData.legendId = data;
        Pay.data.booking.reqData.layout_id = Pay.data.booking.layout.layout_id;
        $scope.shakhterLoader = true;
        if (Pay.data.booking.reservedPlaces.length == Pay.data.booking.selectedEvent.purchase_limit) {
            $scope.shakhterLoader = false;
            return $translate('BOOKING.LIMIT_ERROR').then(function(translation) {
                Notification.error({
                    message: translation,
                    delay: 1000
                });
            });
        } else {
            Pay.data.booking.layout.legends.forEach(function(legend) {
                if (legend.legend_id == Pay.data.booking.reqData.legendId) {
                    if(legend.types.length == 1) {
                        Pay.data.booking.reqData.selectedType = legend.types[0].id;
                        reserveTicket(Pay.data.booking.reqData);
                    } else {
                        angular.element('.modalWindow').attr('style', "width: " + angular.element('.main-panel')[0].clientWidth + "px; "+  "height: " + angular.element('.main-panel')[0].clientHeight + "px");
                        Pay.data.booking.multiTypes.legend = legend;
                        Pay.data.booking.multiTypes.getModalWindow = true;
                        $timeout(function() {
                            angular.element('.modalWindow').find('.window').attr("style", "margin-left: -" + angular.element('.modalWindow').find('.window')[0].clientWidth / 2 + "px;" + "margin-top: -" + angular.element('.modalWindow').find('.window')[0].clientHeight / 2 + "px");
                        }, 10);
                    }
                }
            });
        }
    };

    $scope.reservePlaceWithType = function (type) {
            Pay.data.booking.reqData.selectedType = type.id;
            reserveTicket(Pay.data.booking.reqData);
            Pay.data.booking.multiTypes.getModalWindow = false;

    };

    function reserveTicket(reqData) {
        PortalApi.putReserveTicket(reqData).then(function(resp) {
            if (resp.status == "error") {
                $scope.shakhterLoader = false;
                return $translate('BOOKING.NOT_AVALILABLE').then(function(translation) {
                    Notification.error({
                        message: translation,
                        delay: 1000
                    });
                });
            } else {
                if (Pay.data.booking.reservedPlaces.length == 0) {
                    Pay.data.booking.reserveMin = Pay.data.booking.selectedEvent.reserve_ttl / 60;
                }
                let reservePlace = {
                    internal_id: resp.internal_id,
                    placeInfo: {}
                }

                for (var i = 0; i < Pay.data.booking.layout.legends.length; i++) {
                    if (Pay.data.booking.layout.legends[i].legend_id == Pay.data.booking.reqData.legendId) {
                        reservePlace.placeInfo = angular.copy(Pay.data.booking.layout.legends[i]);

                        reservePlace.placeInfo.types.map(function(type) {
                            if (type.id == resp.type_id) {
                                reservePlace.placeInfo.type = type;
                            }
                        });

                        // change places_available and total summ
                        for (var j = 0; j < Pay.data.booking.layout.legends[i].types.length; j++) {
                            if (Pay.data.booking.layout.legends[i].types[j].id == resp.type_id) {
                                Pay.data.booking.layout.legends[i].types[j].places_available = resp.places_available;
                                if (Pay.data.booking.layout.legends[i].types[j].numberReservedSeats) {
                                    Pay.data.booking.layout.legends[i].types[j].numberReservedSeats += 1;
                                } else {
                                    Pay.data.booking.layout.legends[i].types[j].numberReservedSeats = 1;
                                }
                            }
                        }
                        Pay.data.booking.layout.totalReserveSumm += reservePlace.placeInfo.type.price;
                        //
                    }
                }
                Pay.data.booking.reservedPlaces.push(reservePlace);
                $scope.shakhterLoader = false;
            }
        }, function(reason) {
            $scope.shakhterLoader = false;
            if(reason.data.text_сode == 'LIMIT_EXCEEDED'){
                Localization.notifyTemplate('error', 'BOOKING.LIMIT_ERROR', 5, true);
            }
        });
    };

    $scope.deleteReserve = function(data) {
        if (data.length > 0 && $state.current.name == 'pages.booking') {
            $scope.shakhterLoader = true;
            Pay.data.booking.reqData.removeTicket = [];
            if (angular.isString(data)) {
                Pay.data.booking.reqData.removeTicket.push(data);
            } else {
                data.forEach(function(ticket) {
                    Pay.data.booking.reqData.removeTicket.push(ticket.internal_id);
                })
            }

            PortalApi.deleteReserveTicket(Pay.data.booking.reqData).then(function(resp) {
                for (var i = 0; i < Pay.data.booking.layout.legends.length; i++) {
                    for (var j = 0; j < Pay.data.booking.layout.legends[i].types.length; j++) {
                        resp.forEach(function (ticket) {
                            if (Pay.data.booking.layout.legends[i].types[j].id == ticket.type_id) {
                                Pay.data.booking.layout.legends[i].types[j].places_available = ticket.places_available;
                                Pay.data.booking.layout.legends[i].types[j].numberReservedSeats = Pay.data.booking.layout.legends[i].types[j].numberReservedSeats - 1;
                                Pay.data.booking.layout.totalReserveSumm -= Pay.data.booking.layout.legends[i].types[j].price;
                            }
                        });
                    }
                }

                if (Pay.data.booking.reqData.removeTicket.length == 1) {
                    for (var i = 0; i < Pay.data.booking.reservedPlaces.length; i++) {
                        if (Pay.data.booking.reservedPlaces[i].internal_id == Pay.data.booking.reqData.removeTicket[0]) {
                                Pay.data.booking.reservedPlaces.splice(i, 1);
                        };
                    };
                } else {
                    Pay.data.booking.reservedPlaces = [];
                        for (var i = 0; i < Pay.data.booking.layout.legends.length; i++) {
                            Pay.data.booking.layout.legends[i].numberReservedSeats = 0;
                        };
                        Pay.data.booking.layout.totalReserveSumm = 0;
                }
                if (Pay.data.booking.reservedPlaces.length == 0) {
                    Pay.data.booking.reserveSec = null;
                    $rootScope.$broadcast('timerStop');
                }
                $scope.return();
                $scope.shakhterLoader = false;

                }, function(reason) {
                if(reason.data.text_сode == 'SESSION_ERROR'){
                    Localization.notifyTemplate('error', 'ERROR.OOPS_ERROR', 5, true);
                    $state.go('pages.booking',{service_id:Pay.data.getService.service.id});
                }
            });
        };
    };

    // $scope.moveSVG = function() {
    //     let moveDiv = angular.element('#svgScheme');
    //     window.onmousemove = function (e) {
    //         var x = e.pageX,
    //             y = e.pageY;
    //             moveDiv.attr('style', 'top:' + y + 'px');
    //             moveDiv.attr('style', 'left:' + x + 'px');
    //         // moveDiv.style.top = y + 'px';
    //         // moveDiv.style.left = x + 'px';
    //     }
    // };

    $scope.zoom = function(type) {
        let zoomPoint = angular.copy(Pay.data.booking.currentSVGzoom);
        if (type == '+') {
            zoomPoint += 0.25;
            if (zoomPoint > 2) {
                zoomPoint = 2
            }
            angular.element('#scheme').attr('style', 'transform: matrix('+zoomPoint+', 0, 0,'+zoomPoint+', 0, 0); transform-origin: 50% 50% 0px; cursor: move; transition: transform 400ms ease-in-out;');
        } else if (type == "-") {
            zoomPoint -= 0.25;
            if (zoomPoint < 0.25) {
                zoomPoint = 0.25
            }
            angular.element('#scheme').attr('style', 'transform: matrix('+zoomPoint+', 0, 0,'+zoomPoint+', 0, 0); transform-origin: 50% 50% 0px; cursor: move; transition: transform 400ms ease-in-out;');
        }
        Pay.data.booking.currentSVGzoom = zoomPoint;
    }

    // $scope.clearSVG = function() {
    //     if (angular.element('#svgshema')) {
    //         angular.element('#svgshema').remove();
    //         Pay.data.booking.stadiumScheme = '';
    //     }
    // };
    $scope.return = function () {
            Pay.innerState = 'check';
            Pay.data.booking.step = 1;
            ClientCards.cancelCards();
    };
    $scope.checkTickets = function() {
        for (var i = 0; i < Pay.data.booking.reservedPlaces.length; i++) {
                Pay.fields.forEach(function (field, key) {
                    if (field.alias == 'tickets') {
                        if (field.value) {
                            field.value += ',' + Pay.data.booking.reservedPlaces[i].internal_id;
                        } else {
                            field.value = Pay.data.booking.reservedPlaces[i].internal_id;
                        }
                    }
                });
        }

        let data = {
            data: {
                checkMask: {
                    changeForMask: false
                }
            },
            payment: {
                service_id: Pay.data.booking.serviceId,
                order_id: +new Date()
            },
            fields: Pay.fields,
        };

        Pay.data.preLoader = true;
        PortalApi.checkPayment(data).then(function(response) {
            if (response.status != 'ok') {
                return $translate('NOTIFICATION.ERROR.CHECK_PAYMENT_ERROR').then(function(translation) {
                    Notification.error({
                        message: translation,
                        delay: 1000
                    });
                    Pay.data.preLoader = false;
                });
            } else {
                Pay.data.booking.check = response;
                $scope.pay.payment.id = Pay.data.booking.check.id;
                Pay.data.booking.step = 2;
                $scope.pay.amount = $scope.pay.amountInput = Pay.data.booking.check.data.amount / 100;
                AmountCommission.countAmount();
                Pay.innerState = 'confirm';

                var crData = {
                    amountInput: $scope.pay.amountInput,
                    service: Pay.data.getService.service,
                    subsidy: 0
                };
                PortalApi.createPayment($scope.pay.payment.id, Pay).then(function(response) {
                    if (response.status != 'ok') {
                        return $translate('NOTIFICATION.ERROR.CHECK_PAYMENT_ERROR').then(function(translation) {
                            Notification.error({
                                message: translation,
                                delay: 1000
                            });
                            Pay.data.preLoader = false;
                        });
                    } else {
                        Pay.data.preLoader = false;
                    }
                });
            }
        }, function(reason) {
            if (reason.data.text_сode == 'SESSION_ERROR') {
                Localization.notifyTemplate('error', 'ACTIONS.SIGNOUT', 5, true);
                $state.go('pages.booking',{service_id:Pay.data.getService.service.id});
            }
        });
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/booking/directives/booking.directive.js
 ** module id = 133
 ** module chunks = 1
 **/